import {
    Component,
    OnInit,
    Input,
    Output,
    Inject,
    OnDestroy,
} from '@angular/core';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { AuthenticationService } from '../authentication.service';
import { StateService } from '@uirouter/core';
import * as fromRoot from '../../store/reducers';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromAuth from '../store';

@Component({
    selector: 'ef-sign-in',
    templateUrl: './sign-in.component.html',
    styleUrls: ['./sign-in.component.scss'],
    standalone: false
})
export class SignInComponent implements OnInit, OnDestroy {
    constructor(
        private store: Store<fromRoot.State>,
        private log: LoggingService,
        private authService: AuthenticationService,
        @Inject(StateService) private ss: StateService
    ) {
        log.debug({ type: 'SignInComponent:ctor', store });
    }

    @Output()
    @Input()
    public token$: Observable<string>;

    ngOnDestroy(): void {
    }
    ngOnInit() {
        this.token$ = this.store.pipe(select(fromAuth.getAuthToken));
    }

    openDialog(): void {
        this.authService.openDialog();
    }

    onSignout() {
      this.ss.go('main');
      this.authService.logout();
        // TODO: make this an effect?
    }
}
